export enum ECognitoGetUserExceptions {
  ForbiddenException = 'ForbiddenException',
  InternalErrorException = 'InternalErrorException',
  InvalidParameterException = 'InvalidParameterException',
  NotAuthorizedException = 'NotAuthorizedException',
  PasswordResetRequiredException = 'PasswordResetRequiredException',
  ResourceNotFoundException = 'ResourceNotFoundException',
  TooManyRequestsException = 'TooManyRequestsException',
  UserNotConfirmedException = 'UserNotConfirmedException',
  UserNotFoundException = 'UserNotFoundException'
}

export enum EApiErrorCodes {
  ERR_BAD_REQUEST = 'ERR_BAD_REQUEST',
  STORE_DISABLED = 16
}

export enum EMeasurementUnits {
  cm = 'cm',
  in = 'in'
}

export enum EEntities {
  user = 'user',
  project = 'project',
  category = 'category',
  product = 'product',
  tag = 'tag'
}
